import { useEffect } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import { PaymentMethod } from '@jane/shared/models';

import { useCheckoutPayments } from '../../CheckoutPayments/CheckoutPaymentsProvider';
import { useSubmitCheckout } from './useSubmitCheckout';

// This is essentially a payments spy. When certain tokens/authorizations are captured,
// we automatically submit the checkout.
export const useAutoSubmitCheckout = () => {
  const { selected, canPayIntent, monerisTicket } = useCheckoutPayments();
  const { submit } = useSubmitCheckout();

  const autoSubmit =
    (selected === PaymentMethod.canpay && !!canPayIntent) ||
    (selected === PaymentMethod.moneris && !!monerisTicket);

  useEffect(() => {
    if (autoSubmit) {
      submit();
    }
  }, [canPayIntent, monerisTicket]);
};
